module.exports = {
    customer: 'krediflow',
    assets: { logo: 'SnappyIcon.svg' }
    
};